export const UPDATE_ADDRESS = "UPDATE_ADDRESS";
export const UPDATE_VIRTUOSO_BALANCE = "UPDATE_VIRTUOSO_BALANCE";
export const UPDATE_BALANCE = "UPDATE_BALANCE";
export const UPDATE_VRT1 = "UPDATE_VRT1";
export const UPDATE_PUBLIC_KEY = "UPDATE_PUBLIC_KEY";
export const UPDATE_USERNAME = "UPDATE_USERNAME";
